import { oppositeSortOrder } from 'utils'
import { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { ColumnSorts } from '../../features/Columns'

const useSortMenu = ({ sortItems = [], currentSort }) => {
  const [menu, setMenu] = useState(() => {
    const _sorts = []
      .concat(sortItems)
      .map(({ name }) => ColumnSorts[name])
      .map(({ name, defaultOrder }) => ({
        name,
        order: defaultOrder,
        isActive: false,
      }))

    ;(
      _sorts.find(({ name }) => name === currentSort.name) ||
      _sorts[0] ||
      {}
    ).isActive = true
    return _sorts
  })

  const toggleOrder = useCallback(
    sort => {
      setMenu(_menu =>
        _menu.map(({ name, order, isActive }) => ({
          name,
          isActive,
          order: sort.name === name ? oppositeSortOrder(order) : order,
        }))
      )
    },
    [setMenu]
  )

  const activate = useCallback(
    sort => {
      setMenu(_menu =>
        _menu.map(({ name, order }) => ({
          name,
          isActive: name === sort.name,
          order,
        }))
      )
    },
    [setMenu]
  )

  const activeItem = menu.find(({ isActive }) => isActive)

  return useMemo(
    () => ({
      menu,
      activeItem,
      activate,
      toggleOrder,
    }),
    [activate, activeItem, menu, toggleOrder]
  )
}
useSortMenu.PropType = PropTypes.shape({
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      title: PropTypes.string,
      order: PropTypes.string,
    })
  ),
  activeItem: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    order: PropTypes.string,
  }),
  activate: PropTypes.func,
  toggleOrder: PropTypes.func,
})

export default useSortMenu
